// frontend/admin-portal/src/components/orders/CustomerPicker.jsx
import React, { useEffect, useState, useRef } from "react";
import { Input, Spinner, Button } from "@fiberhome/shared-ui";
import { customerService } from "../../services/customerService";

export default function CustomerPicker({ value, onChange, onCreateNew }) {
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(value || null);
  const debounceRef = useRef(null);

  useEffect(() => {
    setSelected(value || null);
  }, [value]);

  useEffect(() => {
    if (!search) {
      setResults([]);
      return;
    }
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const { items } = await customerService.list({
          search,
          limit: 10,
          isActive: true,
        });
        setResults(items || []);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 300);
    return () => debounceRef.current && clearTimeout(debounceRef.current);
  }, [search]);

  const pick = (c) => {
    setSelected(c);
    onChange?.(c);
    setOpen(false);
    setSearch("");
    setResults([]);
  };

  const clear = () => {
    setSelected(null);
    onChange?.(null);
  };

  return (
    <div className="fh-customer-picker">
      {selected ? (
        <div className="fh-customer-picker__selected">
          <div>
            <div style={{ fontWeight: 600 }}>{selected.name}</div>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {selected.code} {selected.phone ? `· ${selected.phone}` : ""}
              {selected.email ? ` · ${selected.email}` : ""}
            </div>
          </div>
          <div className="d-flex gap-2">
            <Button size="sm" variant="ghost" onClick={clear}>
              Change
            </Button>
          </div>
        </div>
      ) : (
        <>
          <Input
            placeholder="Search customers by name, phone, code..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setOpen(true);
            }}
            onFocus={() => setOpen(true)}
          />
          {open && (
            <div className="fh-customer-picker__results">
              {loading && (
                <div className="p-2 text-muted">
                  <Spinner size="sm" /> Searching…
                </div>
              )}
              {!loading && search && results.length === 0 && (
                <div className="p-2 text-muted" style={{ fontSize: 13 }}>
                  No customers found
                </div>
              )}
              {!loading &&
                results.map((c) => (
                  <button
                    key={c.id}
                    type="button"
                    className="fh-customer-picker__result"
                    onClick={() => pick(c)}
                  >
                    <div style={{ fontWeight: 600 }}>{c.name}</div>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      {c.code} {c.phone ? `· ${c.phone}` : ""}
                    </div>
                  </button>
                ))}
              {onCreateNew && (
                <button
                  type="button"
                  className="fh-customer-picker__new"
                  onClick={() => onCreateNew()}
                >
                  + Create new customer
                </button>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
